import React from "react";
import Modal from "./Modal";
import PrimaryButton from "../components/Buttons/PrimaryButton";
import SecondaryButton from "../components/Buttons/SecondaryButton";
import LoadingIcons from "react-loading-icons";

interface Member {
  id: string;
  user_id: string | null;
  email: string;
  name?: string;
  role: string;
  status: string;
  created_at: string;
}

interface EditRoleModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  editingMember: Member | null;
  editMemberRole: string;
  setEditMemberRole: (role: string) => void;
  editRoleError: string | null;
  editRoleLoading: boolean;
  onUpdateRole: () => void;
}

const EditRoleModal: React.FC<EditRoleModalProps> = ({
  isOpen,
  setIsOpen,
  editingMember,
  editMemberRole,
  setEditMemberRole,
  editRoleError,
  editRoleLoading,
  onUpdateRole,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="w-full">
        <h3 className="text-base font-semibold tracking-tight text-gray-900 mb-0.5">
          Edit member access
        </h3>
        <p className="text-sm text-gray-500 mb-5">
          Update the role for this organisation member.
        </p>

        {editRoleError && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mb-4">
            {editRoleError}
          </p>
        )}

        {editingMember && (
          <div className="space-y-4 mb-5">
            <p className="text-sm text-gray-600">
              Changing role for{" "}
              <span className="font-medium text-gray-900">
                {editingMember.name || editingMember.email}
              </span>
            </p>
            <div>
              <label htmlFor="edit-role" className="block text-sm font-medium text-gray-700 mb-1.5">
                Role
              </label>
              <select
                id="edit-role"
                value={editMemberRole}
                onChange={(e) => setEditMemberRole(e.target.value)}
                className="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#1d365d] focus:border-[#1d365d] transition-colors disabled:bg-gray-50 disabled:cursor-not-allowed"
                disabled={editRoleLoading}
              >
                <option value="member">Member</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          </div>
        )}

        <div className="flex gap-2">
          <SecondaryButton
            type="button"
            onClick={() => setIsOpen(false)}
            disabled={editRoleLoading}
            className="flex-1"
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton
            onClick={onUpdateRole}
            disabled={editRoleLoading}
            className="flex-1"
          >
            {editRoleLoading ? (
              <span className="flex items-center justify-center gap-2">
                <LoadingIcons.TailSpin stroke="#fff" width="16" height="16" />
                Updating...
              </span>
            ) : (
              "Update role"
            )}
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default EditRoleModal;
